import { ProjectUserRole_BugGroupsGeneratedEntity } from "./generated/ProjectUserRole_BugGroupsGeneratedEntity";

export abstract class ProjectUserRole_BugGroupsEntity extends ProjectUserRole_BugGroupsGeneratedEntity {
    // Comment to preserve new line
}
